import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CacheService, MiningToastService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { FilterHandlerService } from 'src/app/modules/core/services/filter/filter-handler.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { ReportLoopByMachineService } from '../../services/report-loop-by-machine.service';
import { LoopByMachineShellComponent } from '../loop-by-machine-shell/loop-by-machine-shell.component';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';

@Component({
  selector: 'app-loop-by-machine-truck-shell',
  templateUrl: './loop-by-machine-truck-shell.component.html',
  styleUrls: ['./loop-by-machine-truck-shell.component.scss'],
})
export class LoopByMachineTruckShellComponent extends LoopByMachineShellComponent implements OnInit {
  constructor(
    protected loopMachineService: ReportLoopByMachineService,
    protected languageService: LanguageService,
    protected layoutConfigService: LayoutConfigService,
    protected progressBarService: BooleanStateService,
    protected filterHandlerService: FilterHandlerService,
    protected cacheService: CacheService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected _excelExportService: ExcelExportService,
    protected _toastService: MiningToastService,
    protected cdr: ChangeDetectorRef,
  ) {
    super(
      loopMachineService,
      languageService,
      layoutConfigService,
      progressBarService,
      filterHandlerService,
      cacheService,
      googleAnalyticsService,
      _excelExportService,
      _toastService,
      cdr,
    );
  }

  /**
   * On init component
   * Assing layout title, message & machine definition
   */
  public ngOnInit(): void {
    this.isLhd = false;
    this.isTruck = true;
    this.initLayoutTitle();
    this.declareFilters();
    this.cdr.detectChanges();
  }
}
